import { Link } from 'react-router-dom';
import { FiFileText, FiSearch, FiTag, FiBookOpen, FiArrowRight } from 'react-icons/fi';

/**
 * Página informativa de Posts y Artículos (para acceder desde el Home)
 */
export default function PostsInfo() {
  return (
    <div className="min-h-full bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl shadow-xl p-8 mb-8 text-white">
          <div className="flex items-center gap-4 mb-4">
            <FiFileText className="w-12 h-12" />
            <h1 className="text-4xl font-bold">
              Posts y Artículos
            </h1>
          </div>
          <p className="text-xl text-indigo-50 mb-6">
            Lee y explora artículos sobre teología, historia bíblica y estudios profundos de las Escrituras.
          </p>
          
          <Link
            to="/estudios"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white text-indigo-600 rounded-lg font-semibold hover:bg-indigo-50 transition-colors shadow-lg"
          >
            Ver Todos los Artículos
            <FiArrowRight className="w-5 h-5" />
          </Link>
        </div>

        {/* Características */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-white rounded-xl shadow-md p-6">
            <FiBookOpen className="w-8 h-8 text-indigo-600 mb-3" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Contenido Curado
            </h3>
            <p className="text-gray-600">
              Artículos escritos y revisados por expertos en teología, historia y estudios bíblicos.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6">
            <FiTag className="w-8 h-8 text-indigo-600 mb-3" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Categorías Organizadas
            </h3>
            <p className="text-gray-600">
              Encuentra artículos por categorías: Teología, Historia, Profecía, Doctrina y más.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6">
            <FiSearch className="w-8 h-8 text-indigo-600 mb-3" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Búsqueda y Filtros
            </h3>
            <p className="text-gray-600">
              Busca por título, descripción o palabras clave. Filtra por categoría y ordena por relevancia.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6">
            <FiFileText className="w-8 h-8 text-indigo-600 mb-3" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Acceso Abierto
            </h3>
            <p className="text-gray-600">
              Todos los artículos publicados están disponibles para lectura sin necesidad de registro.
            </p>
          </div>
        </div>

        {/* Temas Disponibles */}
        <div className="bg-white rounded-xl shadow-md p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Temas que Encontrarás
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="border border-indigo-200 rounded-lg p-4 hover:shadow-md transition-shadow">
              <h4 className="font-semibold text-indigo-900 mb-1">Los Diez Mandamientos</h4>
              <p className="text-sm text-gray-600">Análisis profundo del Decálogo y su aplicación</p>
            </div>

            <div className="border border-indigo-200 rounded-lg p-4 hover:shadow-md transition-shadow">
              <h4 className="font-semibold text-indigo-900 mb-1">El Shabbat</h4>
              <p className="text-sm text-gray-600">Significado y práctica del día de reposo</p>
            </div>

            <div className="border border-indigo-200 rounded-lg p-4 hover:shadow-md transition-shadow">
              <h4 className="font-semibold text-indigo-900 mb-1">Festividades Bíblicas</h4>
              <p className="text-sm text-gray-600">Origen y celebración de las fiestas sagradas</p>
            </div>

            <div className="border border-indigo-200 rounded-lg p-4 hover:shadow-md transition-shadow">
              <h4 className="font-semibold text-indigo-900 mb-1">El Mesías Prometido</h4>
              <p className="text-sm text-gray-600">Profecías y cumplimiento mesiánico</p>
            </div>

            <div className="border border-indigo-200 rounded-lg p-4 hover:shadow-md transition-shadow">
              <h4 className="font-semibold text-indigo-900 mb-1">Las Parábolas</h4>
              <p className="text-sm text-gray-600">Interpretación de las enseñanzas en parábolas</p>
            </div>

            <div className="border border-indigo-200 rounded-lg p-4 hover:shadow-md transition-shadow">
              <h4 className="font-semibold text-indigo-900 mb-1">Historia Bíblica</h4>
              <p className="text-sm text-gray-600">Contexto histórico de eventos bíblicos</p>
            </div>
          </div>
        </div>

        {/* Funcionalidades */}
        <div className="bg-white rounded-xl shadow-md p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Funcionalidades Disponibles
          </h2>
          
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                ✓
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Explorar Artículos Publicados</h4>
                <p className="text-gray-600 text-sm">Navega por más de 10 artículos publicados sobre diversos temas bíblicos y teológicos.</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                ✓
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Filtrar por Categoría</h4>
                <p className="text-gray-600 text-sm">Usa los filtros para encontrar artículos específicos según tu interés.</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                ✓
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Ordenar por Fecha o Popularidad</h4>
                <p className="text-gray-600 text-sm">Ordena los artículos por más recientes, más antiguos o más vistos.</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                ✓
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Lectura Sin Registro</h4>
                <p className="text-gray-600 text-sm">Todos los usuarios pueden leer los artículos sin necesidad de crear una cuenta.</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                ✓
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Administración de Contenido (Usuarios Autorizados)</h4>
                <p className="text-gray-600 text-sm">Los editores y administradores pueden crear, editar y publicar nuevos artículos.</p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Final */}
        <div className="mt-8 text-center">
          <Link
            to="/estudios"
            className="inline-flex items-center gap-2 px-8 py-4 bg-indigo-600 text-white rounded-lg font-semibold text-lg hover:bg-indigo-700 transition-colors shadow-lg"
          >
            <FiFileText className="w-5 h-5" />
            Explorar Artículos
          </Link>
        </div>
      </div>
    </div>
  );
}






